const FAKE_EMAIL_REGX = /@social\.cian\.ru$/;

export function isFakeEmail(email: string): boolean {
  return FAKE_EMAIL_REGX.test(email.toLowerCase());
}
